import Api from '../../utils/api';
import { apiRequest } from '../api';
import { GET_TRIP_LIST } from '../constants';
import * as proto from './_prototype';

export * from './_prototype';

export const getTrip = (token: string) => apiRequest<proto.GetTripRes>({
  label: GET_TRIP_LIST,
  action: Api.consoleBackend('v1/trip', {
    method: 'GET',
    headers: {
      Authorization: `${token}`,
    },
  }),
  fulfilled: (e, _dispatch) => e?.data,
  rejected: (e) => e,
});

export const getTripWithId = (id: string) => apiRequest<proto.GetTripRes>({
  label: GET_TRIP_LIST,
  action: Api.consoleBackend(`v2/trip/${id}`, {
    method: 'GET',
  }),
  fulfilled: (e, _dispatch) => e?.data,
  rejected: (e) => e,
});
